import { PlaygroundPage } from '@/common/pages/playground';

export default function Page() {
  if (process.env.EXPO_PUBLIC_ENV !== 'production') {
    return <PlaygroundPage />;
  }

  return null;
}
